import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Spinner, Text } from '@dixa/lib-shared-habla';
import { typography } from '@dixa/lib-shared-tokens';
import classNames from 'classnames';
import noop from 'lodash/noop';
import styles from './menuItem.module.scss';
export function MenuItem({ onClick, content, color, loading: isLoading, disabled: isDisabled, }) {
    const typographyColor = color && typography.color[color];
    return (_jsxs("li", Object.assign({ role: "button", "aria-disabled": isDisabled, className: classNames(styles.root, {
            [styles.disabled]: isDisabled || isLoading,
        }), onClick: isDisabled || isLoading ? noop : onClick }, { children: [_jsx(Text.Paragraph, Object.assign({ as: "span", color: typographyColor }, { children: content })), isLoading && _jsx(Spinner, { size: 18 })] })));
}
